import { useMutation, useQueryClient } from "@tanstack/react-query";
import { salveazaTargetareScor } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";

export function useSalveazaTargetareScor() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: salveazaTargetareScor,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.scoruri(),
      });
    },
  });
}
